import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import model from '@/reducers/operation/city/model';
import moment from 'moment';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const AreaInfo = ({
    setBreadcrumbPaths,
    match,
    getCompanyCitys,
    companyCitys
}) => {

    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(30);

    useEffect(() => {
        setBreadcrumbPaths(match); // 自动识别面包屑
    }, []);

    useEffect(() => {
        getCompanyCitys({ pageNum, pageSize });
    }, [pageNum, pageSize]);

    const container = {
        width: '100%',
        height: '100%',
    };

    const infoBox = {
        width: '100%',
        height: 'calc(100% - 40px)',
    };

    const footerBox = {
        width: '100%',
        height: '32px',
    };

    const columns = [
        {
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '区县',
            dataIndex: 'areaName',
            key: 'areaName',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士数量',
            dataIndex: 'countRider',
            key: 'countRider',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'statusName',
            key: 'statusName',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '上线时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            align: 'center',
            width: '16%',
            onCell: tooltipStyle,
            render: text => text ? tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss')) : ''
        }
    ];

    return <div style={container} >
        <Table
            style={infoBox}
            rowKey={(r, i) => i}
            columns={columns}
            dataSource={companyCitys.dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            style={footerBox}
            resultTotal={companyCitys.resultTotal}
            pageSize={companyCitys.pageSize}
            pageNum={companyCitys.pageNum}
            onChange={(pageSize, pageNum) => {
                setPageNum(pageNum);
                setPageSize(pageSize);
            }}
        />
    </div>;
};

AreaInfo.propTypes = {
    getCompanyCitys: PropTypes.func,
    companyCitys: PropTypes.object,
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

AreaInfo.defaultProps = {
    companyCitys: { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 },
};

export default connect(state => ({
    companyCitys: state.operationCity.companyCitys,
}), { setBreadcrumbPaths, ...model.actions })(AreaInfo);

